import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { Heading } from '../components/heading'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { PageInfo } from '../components/page-info'
import { Button } from '../components/button'
import { Badge } from '../components/badge'
import { Loader } from '../components/loader';
import { ErrorNotification, SuccessNotification } from '../components/notification';
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '../components/dropdown'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { PlusIcon, RssIcon, EllipsisVerticalIcon } from '@heroicons/react/16/solid';
import { Fragment } from 'react/jsx-runtime'
import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import config from "../config.js"
import { useAlert } from "../components/customAlert";

const pages = [
  { name: "Output Feeds", href: "/output-feeds", current: true },
];
export default function OutputFeeds() {
    const { showAlert } = useAlert();
    const page_info = `Here you can see all the output feeds. If you want to add in a new feed to your account, simply click "Add new feed".`; 
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [feedsList, setFeedsList] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [showSuccessBox, setShowSuccessBox] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [showErrorBox, setShowErrorBox] = useState(false);

    const GotoPage = (pageName) => {
     //   setLoading(true); // Show loader
        setTimeout(() => {
          navigate(`${pageName}`);
        }, 200); // Optional delay for UX smoothness
    };

    const getFeeds = async() => {
      const response = await fetch(`${config.apiPath}output-feed/output-feed-ajax.php?type=output_feed_list`,{ method: 'GET',credentials: 'include' });
      const list_res = await response.json();
      if(list_res.status === 'error') {
        window.location.href = `/${config.appPath}`;
      }
      setFeedsList(list_res.feeds_list);
      setIsDataLoaded(true);
    }
    useEffect(() => {
      getFeeds();
      if (location.state?.message) {
        //toast.success(location.state.message);
        setSuccessMsg(location.state.message);
        setShowSuccessBox(true);
        navigate(location.pathname, { replace: true });
        setTimeout(() => {
          setShowSuccessBox(false);
          setSuccessMsg("");
        }, 3000);
      }
    }, [location, navigate]);

    const RefreshFeed = async(feed_id) => {
      setLoading(true); // Show loader
      const response = await fetch(`${config.apiPath}output-feed/generate-output-feed.php?id=${feed_id}`, { method: 'GET',credentials: 'include' });
      const list_res = await response.json();
      setSuccessMsg(list_res.message);
      setShowSuccessBox(true);
      setLoading(false); // Show loader
      getFeeds();
      setTimeout(() => {
        setShowSuccessBox(false);
        setSuccessMsg("");
      }, 3000);
    };
    const ChangePauseStatus = async(feed_id, status) => {
      setLoading(true); // Show loader
      const response = await fetch(`${config.apiPath}output-feed/output-feed-ajax.php?type=pause_status&status=${status}&feed_id=${feed_id}`, { method: 'GET',credentials: 'include' });
      const list_res = await response.json();
      //setSuccessMsg(list_res.message);
     // setShowSuccessBox(true);
      showAlert(list_res.message, "Status Update" , "success");
      setLoading(false); // Show loader
      getFeeds();
     /*  setTimeout(() => {
        setShowSuccessBox(false);
        setSuccessMsg("");
      }, 3000); */
    };
    const DownloadFeedFile = (filepath) => {
      if(filepath) {
        try {
          setLoading(true); // Show loader
          const url = filepath; 
          const link = document.createElement("a");
          link.href = url;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setLoading(false); // Show loader
        }
        catch (error) {
            setLoading(false);
            setErrorMsg("The file is empty. Please try again later.");
            setShowErrorBox(true);
            setTimeout(() => {
              setShowErrorBox(false);
              setErrorMsg("");
            }, 3000);
        }
      }
      else {
        setErrorMsg("The file is empty. Please try again later.");
        setShowErrorBox(true);
        setTimeout(() => {
          setShowErrorBox(false);
          setErrorMsg("");
        }, 3000);
      }
    };
    const DownloadXML = async (filepath, filename) => {
      if(filepath) {
        try {
          setLoading(true); // Show loader
          const response = await fetch(filepath);

          if (!response.ok) {
            console.error("Failed to fetch file");
            return;
          }

          const blob = await response.blob();
          const url = URL.createObjectURL(blob);

        
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          setLoading(false); // Show loader
        }
        catch (error) {
            setLoading(false);
            setErrorMsg("The file is empty. Please try again later.");
            setShowErrorBox(true);
            setTimeout(() => {
              setShowErrorBox(false);
              setErrorMsg("");
            }, 3000);
        }
      }
      else {
        setErrorMsg("The file is empty. Please try again later.");
        setShowErrorBox(true);
        setTimeout(() => {
          setShowErrorBox(false);
          setErrorMsg("");
        }, 3000);
      }
    };
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="output-feeds">
        <SuccessNotification showSuccessBox={showSuccessBox} successMsg={successMsg} setShowSuccessBox={setShowSuccessBox} />
        <ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
        <BreadcrumbsNew pages={pages} />
        <div className='hidden sm:block'>
          <div className="flex w-full items-center gap-3 !pl-0 rounded-lg px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
            <RssIcon className="!size-8"/>
            <Heading>Output Feeds</Heading>
            <Button className="-my-0.5 inline-flex justify-start" onClick={() => RefreshFeed("")}>Refresh All</Button>
            <Button className="-my-0.5 inline-flex justify-end gap-x-1.5 ml-auto" onClick={() => GotoPage("/edit-output-feed/id/add")}><PlusIcon aria-hidden="true" className="-ml-0.5 size-5" />Add new feed
            </Button>
          </div>
        </div>
        <div className='sm:hidden'>
          <div className="flex w-full items-center gap-3 !pl-0 rounded-lg px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
            <RssIcon className="!size-8"/>
            <Heading>Output Feeds</Heading>
          </div>
          <div className='flex'>
            <Button className="-my-0.5 inline-flex justify-end ml-auto" onClick={() => RefreshFeed("")}>Refresh All</Button>
            <Button className="-my-0.5 inline-flex justify-end gap-x-1.5 ml-2" onClick={() => GotoPage("/edit-output-feed/id/add")}><PlusIcon aria-hidden="true" className="-ml-0.5 size-5" />Add new feed
            </Button>
          </div>
        </div>
        <PageInfo info={page_info} />
      {isDataLoaded ? (
      <Table className="[--gutter:--spacing(6)] lg:[--gutter:--spacing(10)]">
        <TableHead>
          <TableRow>
            <TableHeader>Feed Name</TableHeader>
            <TableHeader>Products</TableHeader>
            <TableHeader>Del.method</TableHeader>
            <TableHeader>Status</TableHeader>
            <TableHeader>Options</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>  
        {
        !Object.keys(feedsList).length ? 
          (<TableRow key="empty">
            <TableCell className="font-medium text-center text-amber-600" colSpan="5">
              Add Output feed to get started.
            </TableCell>
          </TableRow>) :
          (
            feedsList.map((res, index) => (
                <TableRow key={index} className={`${res.paused === 1 ? "bg-orange-50 dark:bg-zinc-950" : ""}`}>
                  <TableCell className="font-medium">
                    <a className="text-indigo-600 hover:text-indigo-900 dark:text-indigo-400 dark:hover:text-indigo-300 cursor-pointer" onClick={() => GotoPage(`/edit-output-feed/id/${res.feed_id}`)}>{res.feed_name}</a>
                  </TableCell>
                  <TableCell>{res.products_total}</TableCell>
                  <TableCell><Badge color={`${res.delivery_method === "HTTP" ? "yellow" : "lime"}`}>{res.delivery_method}</Badge></TableCell>
                  <TableCell>

                  <div>
                    <div className="text-sm font-semibold">Last Refreshed</div>
                    <div className="text-xs/5 text-zinc-600">{res.refreshed_on}</div>
                  </div>
                  </TableCell>
                  <TableCell className="!px-2 !py-2">
                    <Dropdown>
                      <DropdownButton plain aria-label="More options">
                        <EllipsisVerticalIcon />
                      </DropdownButton>
                      <DropdownMenu anchor="bottom end">
                        <DropdownItem onClick={() => GotoPage(`/edit-output-feed/id/${res.feed_id}`)}>Edit</DropdownItem>
                        <DropdownItem onClick={() => RefreshFeed(res.feed_id)} disabled={res.paused === 1}>Refresh Now</DropdownItem>
                        <DropdownItem onClick={() => DownloadFeedFile(res.feed_url_zip)}>Download as ZIP</DropdownItem>
                        <DropdownItem onClick={() => DownloadXML(res.feed_url, res.output_filename)}>Download a raw file</DropdownItem>
                        <DropdownItem onClick={() => DownloadFeedFile(res.feed_url_excel)}>Download Excel</DropdownItem>
                        { !res.paused ? (<DropdownItem onClick={() => ChangePauseStatus(res.feed_id, 1)}>
                          Pause
                        </DropdownItem>) : 
                        (<DropdownItem onClick={() => ChangePauseStatus(res.feed_id, 0)}>
                          Resume
                        </DropdownItem>)
                        }
                      </DropdownMenu>
                    </Dropdown>
                  </TableCell>
                </TableRow>
            ))
          )
        }
        </TableBody>
      </Table>
      ) : <Loader />
        }
      {loading && (
        <Loader />
      )}
       </SidebarLayoutNew>
    </Fragment>
  );
}